import { Button } from '@/ui/design-system/components/ui/button';
import Link from 'components/Link';
import { cn } from '@/ui/design-system/utils/cn';
import { forwardRef } from 'react';
import { withMixpanelClick } from 'utils/app';

const SoftButtonLinkInner = forwardRef(function SoftButtonLinkInner(
    {
        IconLeft,
        IconRight,
        children,
        isDisabled,
        size = 'sm',
        wrapText = false,
        mixpanelContext,
        className,
        to,
        smooth,
        ...props
    },
    ref,
) {
    return (
        <Button
            ref={ref}
            variant="ghost"
            size={size}
            disabled={!!isDisabled}
            asChild
            className={cn(
                'no-underline',
                wrapText && 'whitespace-normal',
                className,
            )}
            {...props}
        >
            <Link to={to} smooth={smooth}>
                {IconLeft && (
                    <span className="size-4 shrink-0 flex items-center">
                        <IconLeft className="!size-[1.2em] shrink-0 opacity-50" />
                    </span>
                )}
                {children}
                {IconRight && (
                    <span className="size-4 shrink-0 flex items-center">
                        <IconRight className="!size-[1.2em] shrink-0 opacity-50" />
                    </span>
                )}
            </Link>
        </Button>
    );
});

const SoftButtonLink = withMixpanelClick(SoftButtonLinkInner, 'SoftButtonLink');

export default SoftButtonLink;
